import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toJS } from '../../../utils/immutableUtils';
import { getProductAreaList } from '../actions';
import {
  getProductArea,
  getProductAreaError,
  isProductAreaFetched
} from '../selectors';

const useProductArea = ({ forceFetch = false } = {}) => {
  const dispatch = useDispatch();

  const [isMounted, setIsMounted] = useState(false);
  const productAreaList = useSelector(getProductArea);
  const isFetchingProductArea = useSelector(isProductAreaFetched);
  const fetchError = useSelector(getProductAreaError);
  const isFetching = !isMounted ? true : isFetchingProductArea;
  const isFetched = !!productAreaList;

  useEffect(() => {
    if (isMounted) {
      return;
    }
      if (!isFetched || forceFetch) {
        dispatch(getProductAreaList());
      }
    setIsMounted(true);
  }, [dispatch, forceFetch, isFetched, isMounted]);

  return [isFetching, isFetching ? null : toJS(productAreaList), fetchError];
};

export default useProductArea;
